angular
    .module('claimVic.controller')
    .controller('claimDetailsVicController', ['$scope', '$rootScope', '$filter', '$timeout', 'httpService', 'commonService', 'commonConst', 'policyService', 'claimSumm', 'policySumm', 'inboxService', 'popupService',
        function ($scope, $rootScope, $filter, $timeout, httpService, commonService, commonConst, policyService, claimSumm, policySumm, inboxService, popupService) {
            $rootScope.pageName = "Claim Details";
            $scope.createdDate = 'createdDate';
            $scope.dateFilter = {
                dateFrom: "",
                dateTo: "",
            };

            $scope.dateSearchFrom = "";
            $scope.dateSearchTo = "";
            $rootScope.etlTime;
            $scope.ClaimDetails;
            $scope.serverResponse;
            $scope.showSearchDate = false;
            // using for math.abs in view
            $scope.Math = window.Math;
            $scope.isNSIEmployer = $filter('dec2bool')(sessionStorage.IsNsiUser) && !$filter('dec2bool')(sessionStorage.IsClaimant);

            $scope.document = {
                documentList: [],
                documentVisible: false,
                documentPageCount: 0
            }

            $scope.pageBreadcrumbs = [{
                url: '/',
                title: 'Home'
            }, {
                url: '#',
                title: 'My Policies & Claims',
                action: 'openSelectPolicyForVicClaim()'
            }, {
                url: '#',
                title: 'My Claims Summary',
                action: "viewClaimSummary(ClaimDetails.EmployerId, ClaimDetails.Scheme)"
            }, {
                url: null,
                title: 'Claim Details'
            }];
            $scope.selectPolicyAction = policyService.getSelectPolicyAction();
            $scope.isNeedReview = false;

            $scope.init = function () {
                $scope.claimId = $rootScope.pageNavigationHistory.claim.ClaimId;
                $scope.Scheme = $rootScope.pageNavigationHistory.claim.Scheme;
                $scope.claimNumber = $rootScope.pageNavigationHistory.claim.ClaimNumber;
                $rootScope.getClaimDetails($scope.claimId, $scope.Scheme);

                // if nsi employer, My Claims url should be my-claim
                if (!$rootScope.user.IsClaimant && $scope.Scheme === 1) {
                    $scope.pageBreadcrumbs[2].action = 'navigateToPIClaimSummary()';
                }

                if ($rootScope.user.IsClaimant) {
                    if ((typeof ($rootScope.previousClaimCount) === "undefined" || $rootScope.previousClaimCount === null)) {
                        claimSumm.getClaimCountByIdentifier().then(function (claimCount) {
                            $rootScope.previousClaimCount = claimCount;
                            if ($rootScope.previousClaimCount === 1) {
                                $scope.removeBreadCrumb('My Claims Summary');
                            }
                        });
                    }

                    if ($rootScope.previousClaimCount === 1) {
                        $scope.removeBreadCrumb('My Claims Summary');
                    }
                }

                // remove Breadcrumbs My Policies & Claims if worker or NSI
                if ($rootScope.user.IsClaimant || $scope.Scheme === 1 || $rootScope.previousPolicyCount === 1) {
                    $scope.removeBreadCrumb('My Policies & Claims');
                } else {
                    if ((typeof ($rootScope.previousPolicyCount) === "undefined" || $rootScope.previousPolicyCount === null)) {
                        policySumm.getPolicyCount(1).then(function (policyCount) {
                            $rootScope.previousPolicyCount = policyCount;
                            if ($rootScope.previousPolicyCount === 1) {
                                $scope.removeBreadCrumb('My Policies & Claims');
                            }
                        });
                    }
                }

                if (window.innerWidth < 768) {
                    $scope.panelStyle = '';
                }
            }

            $rootScope.getClaimDetails = function (claimId, Scheme) {
                var APITarget = "api/vicclaims/getvicclaimdetail";
                var Values = JSON.stringify({
                    Identifier: $rootScope.user.Identifier,
                    SessionKey: $filter('decstr64')($rootScope.user.SessionKey),
                    ClaimId: claimId,
                    DateOfBirth: $rootScope.user.DateOfBirth,
                    IsClaimant: $rootScope.IsClaimant
                });
                httpService.httpRequest(APITarget, Values).then(function (data) { // this is only run after $http completes
                    if (data !== false) {
                        if (data === "logout") {
                            $rootScope.userLogout();
                        }
                        $scope.serverResponse = angular.fromJson(data);
                        $scope.ClaimDetails = $scope.serverResponse;
                        // Bind Claim Details data
                        $rootScope.MyClaimsContents = [];
                        $rootScope.MyClaimsContents.push({
                            claimDetails: "",
                            claimTitle: angular.toJson($scope.ClaimDetails),
                            visible: false
                        });
                        //Bind payment for vic user
                        benefitsClaimDetail(claimId, 0);
                        if (Scheme === 1) {
                            initNSIDocData();

                            if ($rootScope.user.AllowReviewClaim === true && $scope.ClaimDetails.ClientId === 111 && $scope.ClaimDetails.IsNeedReview && $scope.ClaimDetails.IncidentNumber) {
                                $scope.isNeedReview = true;
                            }
                        }
                        if (Scheme === 0) {
                            $scope.hideEtlTime = $scope.ClaimDetails.IsMigrated;
                        }

                        commonService.saveRecentPolicyAndClaim(commonConst.CLAIM, new PolicyModel($scope.serverResponse), new ClaimModel($scope.serverResponse));
                    }
                });

            }; //getPolicyDetails

            //TO DO IMPROVE
            $rootScope.pageName;
            $rootScope.etlTime;
            $rootScope.MyClaims;
            $rootScope.MyClaimsContents = [];
            $rootScope.ShowLoadMoreWagePaymentButton = false;
            $rootScope.ShowLoadMoreOtherPaymentButton = false;
            $scope.WagePaymentPageNumber = $scope.ReimbursementPageNumber = $scope.DocumentPageNumber = 1;
            $scope.WagePaymentRowsPerPage = $scope.ReimbursementRowsPerPage = $scope.DocumentRowsPerPage = 10;

            function benefitsClaimDetail(claimId, indexClaim) {
                $scope.claimId = claimId;
                if ($rootScope.MyClaimsContents[indexClaim].claimDetails === "") {
                    var APITarget = $rootScope.user.IsClaimant || $rootScope.user.IsNsiUser ? "api/claims/viewnsimoneydetail" : "api/vicclaims/viewvicmoneydetail";
                    var Values = JSON.stringify({
                        Identifier: $rootScope.user.Identifier,
                        SessionKey: $filter('decstr64')($rootScope.user.SessionKey),
                        ClaimId: claimId,
                        WagePaymentRowsPerPage: $scope.WagePaymentRowsPerPage,
                        WagePaymentPageNumber: $scope.WagePaymentPageNumber,
                        ReimbursementRowsPerPage: $scope.ReimbursementRowsPerPage,
                        ReimbursementPageNumber: $scope.ReimbursementPageNumber,
                        IsClaimant: $rootScope.IsClaimant
                    });

                    httpService.httpRequest(APITarget, Values).then(function (data) { // this is only run after $http completes
                        if (data !== false) {
                            if (data === "logout") {
                                $rootScope.userLogout();
                            }

                            $scope.serverResponse = angular.fromJson(data);
                            $scope.MyBenefitDetails = $scope.serverResponse;

                            $rootScope.MyClaimsContents[indexClaim].visible = true;
                            $rootScope.MyClaimsContents[indexClaim].claimDetails = $scope.MyBenefitDetails;
                            $rootScope.MyClaimsContents[indexClaim].claimDetails.wagePaymVisible = false;
                            $rootScope.MyClaimsContents[indexClaim].claimDetails.reimbPaymVisible = false;
                            $rootScope.ShowLoadMoreWagePaymentButton = $scope.WagePaymentPageNumber < $scope.MyBenefitDetails.WagePaymentPageCount;
                            $rootScope.ShowLoadMoreOtherPaymentButton = $scope.ReimbursementPageNumber < $scope.MyBenefitDetails.ReimbursementPageCount;
                        } //if data==false

                    }); //httpService
                } else {
                    $rootScope.MyClaimsContents[indexClaim].claimDetails = "";
                    $rootScope.MyClaimsContents[indexClaim].visible = false;
                }

            }; //claimantClaimDetail

            function initNSIDocData() {
                $scope.documentData = {
                    esSearchCursor: null,
                    isFavoriteOnly: false,
                    documentPageNumber: 1,
                    documentRowsPerPage: 10,
                    isSortDesc: true,
                    filterCategories: [],
                    claimId: $scope.claimId
                };

                $scope.refreshListDocument();

                if ($rootScope.IsClaimant) {
                    $scope.listCategories = [{
                            id: 8,
                            name: 'Claim Mail'
                        },
                        {
                            id: 5,
                            name: 'Investigations'
                        },
                        {
                            id: 4,
                            name: 'Legal'
                        },
                        {
                            id: 1,
                            name: 'Medical'
                        },
                        {
                            id: 2,
                            name: 'Medical Certificates'
                        },
                        {
                            id: 3,
                            name: 'Payments'
                        },
                        {
                            id: 6,
                            name: 'Rehabilitation'
                        },
                        {
                            id: 7,
                            name: 'Work Capacity'
                        }
                    ];
                } else {
                    $scope.listCategories = [{
                            id: 2,
                            name: 'Medical Certificates'
                        },
                        {
                            id: 6,
                            name: 'Rehabilitation'
                        }
                    ];
                }

                $timeout(function () {
                    $('#filter-category').multiselect({
                        dropRight: true,
                        includeSelectAllOption: true,
                        selectedClass: '',
                        buttonText: function (ele, checked) {
                            return '';
                        },
                        templates: {
                            button: '<i class="multiselect dropdown-toggle fa fa-filter" data-toggle="dropdown"></i>'
                        },
                        onChange: function (ele, checked) {
                            $scope.documentData.filterCategories = $('#filter-category').val();
                            $scope.refreshListDocument();
                        },
                        onSelectAll: function () {
                            $scope.documentData.filterCategories = $('#filter-category').val();
                            $scope.refreshListDocument();
                        },
                        onDeselectAll: function () {
                            $scope.documentData.filterCategories = null;
                            $scope.refreshListDocument();
                        }
                    });
                }, 50);
            }

            $scope.loadMoreWage = function (indexClaim) {
                $scope.WagePaymentPageNumber += 1;
                var WagePaymentRowsPerPage = 10;
                var APITarget = $rootScope.user.IsClaimant || $rootScope.user.IsNsiUser ? "api/claims/viewnsimoneydetail" : "api/vicclaims/viewvicmoneydetail";
                var Values = JSON.stringify({
                    Identifier: $rootScope.user.Identifier,
                    SessionKey: $filter('decstr64')($rootScope.user.SessionKey),
                    ClaimId: $scope.claimId,
                    WagePaymentRowsPerPage: WagePaymentRowsPerPage,
                    WagePaymentPageNumber: $scope.WagePaymentPageNumber,
                    IsClaimant: $rootScope.IsClaimant
                });

                httpService.httpRequest(APITarget, Values).then(function (data) { // this is only run after $http completes
                    if (data !== false) {
                        if (data === "logout") {
                            $rootScope.userLogout();
                        }

                        $scope.serverResponse = angular.fromJson(data);
                        angular.forEach($scope.serverResponse.ClaimWagePaymentPeriodList, function (item, index) {
                            $rootScope.MyClaimsContents[indexClaim].claimDetails.ClaimWagePaymentPeriodList.push(item);
                        });

                        $rootScope.ShowLoadMoreWagePaymentButton = $scope.WagePaymentPageNumber < $scope.serverResponse.WagePaymentPageCount;
                    }
                });
            }

            // Load more Other Payment
            $scope.loadMoreReimbursement = function (indexClaim) {
                $scope.ReimbursementPageNumber += 1;
                var ReimbursementRowsPerPage = 10;
                var APITarget = $rootScope.user.IsClaimant || $rootScope.user.IsNsiUser ? "api/claims/viewnsimoneydetail" : "api/vicclaims/viewvicmoneydetail";
                var Values = JSON.stringify({
                    Identifier: $rootScope.user.Identifier,
                    SessionKey: $filter('decstr64')($rootScope.user.SessionKey),
                    ClaimId: $scope.claimId,
                    ReimbursementRowsPerPage: ReimbursementRowsPerPage,
                    ReimbursementPageNumber: $scope.ReimbursementPageNumber,
                    IsClaimant: $rootScope.IsClaimant
                });

                httpService.httpRequest(APITarget, Values).then(function (data) { // this is only run after $http completes
                    if (data !== false) {
                        if (data === "logout") {
                            $rootScope.userLogout();
                        }

                        $scope.serverResponse = angular.fromJson(data);
                        angular.forEach($scope.serverResponse.ClaimReimbursementList, function (item, index) {
                            $rootScope.MyClaimsContents[indexClaim].claimDetails.ClaimReimbursementList.push(item);
                        });

                        $rootScope.ShowLoadMoreOtherPaymentButton = $scope.ReimbursementPageNumber < $scope.serverResponse.ReimbursementPageCount;
                    }
                });
            }

            //Load more NSI Document
            $scope.refreshListDocument = function () {
                $scope.documentData.documentPageNumber = 1;
                $scope.documentData.esSearchCursor = null;

                $scope.queryDocuments();
            }

            $scope.queryDocuments = function () {
                $rootScope.rollingLoader = true;
                inboxService.getClaimDocuments($scope.documentData).then(function (serverResponse) {
                    $rootScope.rollingLoader = false;
                    if ($scope.documentData.documentPageNumber === 1) {
                        $scope.documentList = serverResponse.DocumentList;
                        $scope.documentData.documentPageCount = serverResponse.DocumentPageCount;
                    } else {
                        angular.forEach(serverResponse.DocumentList, function (item, index) {
                            $scope.documentList.push(item);
                        });
                    }

                    $scope.ShowLoadMoreDocumentButton = $scope.documentData.documentPageNumber < serverResponse.DocumentPageCount;
                    $scope.documentData.documentPageNumber += 1;
                    $scope.documentData.esSearchCursor = serverResponse.EsSearchCursor;
                    $scope.dateFilter.dateFrom = angular.copy($scope.documentData.receivedDateFrom);
                    $scope.dateFilter.dateTo = angular.copy($scope.documentData.receivedDateTo);
                    //$scope.$apply()
                });
            }

            $scope.switchSortOrder = function () {
                $scope.documentData.isSortDesc = !$scope.documentData.isSortDesc;
                $scope.refreshListDocument();
            }

            $scope.updateFavoriteDocument = function (document) {
                inboxService.updateFavoriteDocument(document.Name_, !document.IsFavorite_).then(function (response) {
                    document.IsFavorite_ = !document.IsFavorite_;
                });
            }

            $scope.switchFavoriteFilter = function () {
                $scope.documentData.isFavoriteOnly = !$scope.documentData.isFavoriteOnly;
                $scope.refreshListDocument();
            }

            $scope.viewDocument = function (document, act) {
                inboxService.viewDocument(document, act);
            };

            $scope.exportWagePayments = function () {
                var APITarget = "api/vicclaims/exportwagepaymentexcelfile";
                var Values = JSON.stringify({
                    Identifier: $rootScope.user.Identifier,
                    SessionKey: $filter('decstr64')($rootScope.user.SessionKey),
                    Keyword: "",
                    EmployerId: $scope.employerId,
                    ClaimId: $scope.claimId,
                    IsClaimant: $rootScope.user.IsClaimant
                });
                var options = {
                    responseType: 'arraybuffer'
                };
                httpService.httpRequest(APITarget, Values, 'GET', options).then(function (data) { // this is only run after $http completes
                    if (angular.isDefined(data.File)) {
                        var file = new Blob([data.File], {
                            type: 'text/csv'
                        });
                        var fileName = '';

                        if ($rootScope.user.IsClaimant || $rootScope.user.IsNsiUser) {
                            fileName = $scope.claimNumber.trim() + '_' + $scope.ClaimDetails.FullName.trim().replace(/ /g, '') + '_WeeklyBenefits_' + commonService.formatDate(new Date()) + '.csv'
                        } else if ($scope.ClaimDetails.Scheme === 0) {
                            fileName = 'icareNSW_' + $scope.claimNumber.trim() + '_WeeklyPayments_' + commonService.formatDate(new Date()) + '.csv'
                        } else if ($scope.ClaimDetails.Scheme === 2) {
                            fileName = 'WorkSafeVictoria_' + $scope.claimNumber.trim() + '_WeeklyPayments_' + commonService.formatDate(new Date()) + '.csv'
                        }
                        saveAs(file, fileName);
                        return true;
                    } else
                        return false;
                });
            };

            $scope.exportOtherPayments = function () {
                var APITarget = "api/vicclaims/exporotherpaymentexcelfile";
                var Values = JSON.stringify({
                    Identifier: $rootScope.user.Identifier,
                    SessionKey: $filter('decstr64')($rootScope.user.SessionKey),
                    Keyword: "",
                    EmployerId: $scope.employerId,
                    ClaimId: $scope.claimId,
                    IsClaimant: $rootScope.user.IsClaimant
                });
                var options = {
                    responseType: 'arraybuffer'
                };
                httpService.httpRequest(APITarget, Values, 'GET', options).then(function (data) { // this is only run after $http completes
                    if (angular.isDefined(data.File)) {
                        var file = new Blob([data.File], {
                            type: 'text/csv'
                        });

                        var fileName = '';
                        var exportFileName = !$rootScope.user.IsClaimant ? '_OtherPayments_' : '_Reimbursements_';
                        if ($rootScope.user.IsClaimant || $rootScope.user.IsNsiUser) {
                            fileName = $scope.claimNumber.trim() + '_' + $scope.ClaimDetails.FullName.trim().replace(/ /g, '') + exportFileName + commonService.formatDate(new Date()) + '.csv'
                        } else if ($scope.ClaimDetails.Scheme === 0) {
                            fileName = 'icareNSW_' + $scope.claimNumber.trim() + exportFileName + commonService.formatDate(new Date()) + '.csv'
                        } else if ($scope.ClaimDetails.Scheme === 2) {
                            fileName = 'WorkSafeVictoria_' + $scope.claimNumber.trim() + exportFileName + commonService.formatDate(new Date()) + '.csv'
                        }

                        saveAs(file, fileName);
                        return true;
                    } else
                        return false;
                });
            };

            $scope.removeBreadCrumb = function (name) {
                var index = $scope.pageBreadcrumbs.findIndex(function (x) {
                    return x.title === name;
                })

                if (index >= 0) {
                    $scope.pageBreadcrumbs.splice(index, 1);
                }
            }

            $scope.toUploadDocument = function () {
                $rootScope.navigate('/upload-document');
            }

            $scope.openClaimReviewPopup = function () {
                claimSumm.checkClaimReview($scope.claimId).then(function (data) {
                    if (data.Success === true) {
                        var otpions = {
                            showHeader: false,
                            showCloseButton: false,
                            otherTheme: false,
                            additionClass: 'claim-review-popup'
                        };

                        popupService.show('claimVic', 'review_claim-details', otpions);
                    } else {
                        popupService.showError(data.ErrorMessage);
                    }
                });

            }

            $scope.clearDateSearch = function () {
                $scope.documentData.receivedDateFrom = "";
                $scope.documentData.receivedDateTo = "";
                $scope.refreshListDocument();
            }

            $scope.applyDateChange = function (dateFrom, dateTo) {
                $scope.documentData.receivedDateFrom = dateFrom;
                $scope.documentData.receivedDateTo = dateTo;
                $scope.refreshListDocument();
            }

        }
    ]);